import React from 'react';
import {VpnUsage} from '@src/dtos/device.dto';

interface DevicesVpnUsageCellProps {
    vpnUsage: VpnUsage | null;
}

const clampRatio = (ratio: number): number =>
    Number.isFinite(ratio) ? Math.max(0, Math.min(1, ratio)) : 0;

const ratioToPercent = (ratio: number): string =>
    `${Number((ratio * 100).toFixed(4))}%`;

export const formatUsagePercent = (usagePercent: number): string => {
    if (!Number.isFinite(usagePercent)) {
        return '0';
    }
    return String(Math.round(usagePercent * 10) / 10);
};

export const DevicesVpnUsageCell: React.FC<DevicesVpnUsageCellProps> = ({vpnUsage}) => {
    if (!vpnUsage) {
        return null;
    }

    return <div className="devices-vpn-usage-cell">
        <div className="vpn-usage-bar" role="img" aria-label={`VPN connected ${formatUsagePercent(vpnUsage.usagePercent)}% during the last 30 days`}>
            {vpnUsage.connectedSegments.map((segment, index) => {
                const start = clampRatio(segment.startRatio);
                const end = Math.max(start, clampRatio(segment.endRatio));

                return end > start
                    ? <span key={`${segment.startRatio}-${segment.endRatio}-${index}`}
                            className="vpn-usage-connected-segment"
                            style={{
                        left: ratioToPercent(start),
                        width: ratioToPercent(end - start),
                            }}/>
                    : null;
            })}
        </div>
        <span className="vpn-usage-percent">{formatUsagePercent(vpnUsage.usagePercent)}%</span>
    </div>;
};
